export class ToolbarItem {
    
    xtype?: string;
    
    itemId: string;
    
    iconSVG? : string;
    
    iconURL? : string;
    
    title?: string;
    
    element?: HTMLElement;
    
}
